module.exports = __webpack_public_path__ + "static/oaf-8539f68222cb2d6d12a068001c59d7c2.jpg";